import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { Globe, Lock } from 'lucide-react';
import { DialplanNodeData } from '@/types/dialplan-nodes';

export const PublicEntryNode: React.FC<NodeProps<DialplanNodeData>> = ({ data, selected }) => {
  return (
    <div
      className={`
        px-4 py-3 rounded-lg border-2 bg-gradient-to-br from-green-50 to-green-100
        ${selected ? 'border-green-500 shadow-lg' : 'border-green-300 shadow'}
        min-w-[180px]
      `}
    >
      <div className="flex items-center gap-2 mb-2">
        <Globe className="h-5 w-5 text-green-600" />
        <div className="flex-1">
          <div className="font-semibold text-green-900">{data.label}</div>
          {data.description && (
            <div className="text-xs text-green-700">{data.description}</div>
          )}
        </div>
        <Lock className="h-4 w-4 text-green-600" aria-label="Cannot be deleted" />
      </div>
      
      {data.priority !== undefined && (
        <div className="text-xs text-green-700 mt-1">
          Priority: {data.priority}
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        className="!bg-green-500 !w-3 !h-3"
      />
    </div>
  );
};

